module.exports = __webpack_public_path__ + "img/SPALogo-small.3cf85000.svg";